import React, { memo } from "react"
import { Box, makeStyles } from "@material-ui/core"
import { Icon, LinkButton } from ".."
import { RowBox } from "../Boxes"

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.text.tinted,
    fontSize: 13,
    fontWeight: "500",
    "&:disabled": {
      color: theme.palette.text.disabled,
      cursor: "default",
    },
    "&:focus": {
      outline: "none",
    },
  },
}))

const ActionCardFooterButton = memo(function ActionCardFooterButton({
  icon,
  label,
  onClick,
  iconClassName = "",
  loading,
  ...rest
}) {
  const classes = useStyles()

  return (
    <LinkButton className={classes.button} onClick={onClick} {...rest}>
      <RowBox>
        <Icon name={icon} className={iconClassName} />
        <Box ml={0.5}>{label}</Box>
      </RowBox>
    </LinkButton>
  )
})

export default ActionCardFooterButton
